<template>
  <!-- 图表加载中 -->
  <div
    v-show="isLoading"
    class="skeleton-loading"
    :style="{ width: width, height: height }"
  >
    <div class="skeleton-loading-text">
      <svg class="icon btn-loading" aria-hidden="true" style="font-size: 25px">
        <use xlink:href="#icon-v4_loading_chart"></use>
      </svg>
      <div class="txt">
        <!-- 加载中 -->
        {{ $t("lanV4.loading") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    loading(v) {
      this.isLoading = v;
    },
  },
  mounted() {
    this.isLoading = this.loading;
  },
};
</script>
<style lang="scss" scoped>
.skeleton-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  .skeleton-loading-text {
    text-align: center;
    color: #86909c;
    .txt {
      font-size: 12px;
      margin-top: 12px;
    }
  }
}
</style>